import richText from "utilities/richText"
import cn from "classnames"

export default function FeaturedList({ blok }) {
  return (
    <div
      className={cn(
        "featured-list prose:list-disc-none prose mb-6 rounded-10 p-6 prose-h4:mb-5 prose-li:pb-[2px] prose-li:font-bold bg-stone-light",
      )}
    >
      {richText(blok.main_content)}
    </div>
  )
}
